import React, { useEffect, useRef, useMemo, forwardRef, useState } from 'react';
import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
import axios from 'axios';
import swal from 'sweetalert';
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Dropdown } from 'react-bootstrap';
import { CSVLink } from 'react-csv';
import RepairOrderModal from '../jsx/constant/EditRepairOrder'; // Assume this is your modal component
import { COLUMNS } from '../jsx/components/table/FilteringTable/RepairOrderColumns'; // Your column definitions
import InviteCustomer31 from '../jsx/constant/ArbonAmount';
import InviteCustomer3 from '../jsx/constant/RestAmount';
import InviteCustomer4 from './Invoiceextendrepairorder';
import InviteCustomer from '../jsx/constant/CitiesModal';
import InviteCustomer11 from '../components/NextMaintainceDate';
import InviteCustomer2 from '../jsx/constant/CitiesModal';

import { Modal } from 'react-bootstrap';
import { Next } from 'react-bootstrap/esm/PageItem';

const RepairOrders = forwardRef((props, ref) => {
  const columns = useMemo(() => COLUMNS, []);
  const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);
  const invite11 = useRef();

  const navigate = useNavigate(); // Use useNavigate hook for navigation
  const [data3, setData3] = useState({});
  const [PrePay, setPrePay] = useState('');
  const [total, settotal] = useState(null);
  const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
  const [Amount, setAmount] = useState('')
  const [reastAmount, setReastAmount] = useState('')
    const [PaymentMethod, setPaymentMethod] = useState('')

  const [Err, setERrr] = useState('');
  const [popupModal, setpopupModal] = useState(false)
  const [popupModal1, setpopupModal1] = useState(false)

  const [report, setreport] = useState({})
  const [RepairOrderID, setRepairOrderID] = useState('')
  const [shouldFetch, setShouldFetch] = useState(false); // triggers re-fetching
  const [datareparorder, setdatareparorder] = useState([]);
  const [datareparorderDetails, setdatareparorderDetails] = useState([]);

  const invite31 = useRef();
  const invite3 = useRef();
  const invite4 = useRef();
  const invite = useRef();

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  )
  function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'WeddingHall';
  const actionsForPage = getActionsForPage(pageName);



  // const fetchRepairOrders = async () => {
  //   try {
  //     const response = await axios.get('https://subk.education.com.ly/back/api/repairOrder');
  //     setData(response.data);
  //     console.log('data', data)
  //     console.log('response.data', response.data)

  //   } catch (error) {
  //     console.error('Error fetching repair orders:', error);
  //   }
  // };
  const fetchRepairOrders = async () => {
    if (!chassisNumber && !customerName && !repairDate) {
      // لو مافيش أي فلتر → ما يجيبش حاجة
      setData([]);
      return;
    }

    try {
         const response = await axios.get('https://subk.education.com.ly/back/api/repairOrder', {
        params: {
          chassis: chassisNumber || undefined,
          name: customerName || undefined,
          date: repairDate || undefined,
        },
      });
      setData(response.data);
    } catch (error) {
      console.error("Error fetching repair orders:", error);
    }
  };

  function orderlist(id) {

    data.map((item) => {
      if (id == item.RepairOrderID) {
        setPrePay(item.Prepay)
        settotal(item.TotalCost)
        setRepairOrderID(id)

        setReastAmount(parseFloat(item.RestAmount) || 0)
        setERrr('')
        if ((parseFloat(item.RestAmount) || 0) == 0 && (item.RepairStatus === 'مكتملة')) {
          swal("this Repair Order fully Paid");

        } else {
          setpopupModal(true)
        }


      }
    })
  }
  function orderlist1(id) {

    data.map((item) => {
      if (id == item.RepairOrderID) {
        setPrePay(item.Prepay)
        settotal(item.TotalCost)
        setRepairOrderID(id)

        setReastAmount(parseFloat(item.RestAmount) || 0)
        setERrr('')
        if ((parseFloat(item.RestAmount) || 0) == 0 && (item.RepairStatus === 'مكتملة')) {
          swal("this Repair Order fully Paid");

        } else {
          setpopupModal1(true)
        }


      }
    })
  }


  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
  const userid = userData.id;
  const username = userData.name;
  const handleEdit1 = () => {
    console.log(Amount)
    console.log(PrePay)
    console.log(RepairOrderID)
 if (!PaymentMethod) {
    alert("من فضلك اختر طريقة الدفع");
    return;
  }
    setERrr('');
    if (Amount > reastAmount) {
      setERrr('القيمة المدخلة اكبر من القيمة المتبقية')
    }


    else {
      console.log("in pther")

      const error = axios.post(`https://subk.education.com.ly/back/api/invoices`, {
        ['AmountDue']: Amount,
        ['UserID']: userid,
        ['RepairOrderID']: RepairOrderID,
        ['PaymentMethod']: PaymentMethod,

      }).then(res => {
        fetchRepairOrders();

      });
      if (!error.response) {

      } else {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
      console.log(error.config);
    }
    setAmount('')
    setReastAmount('')
    setERrr('')
    // setShouldFetch(!shouldFetch); // toggle to refetch
    //fetchRepairOrders();
    setpopupModal(false)
    settotal('')


  }
  const handledeposit = () => {
    setERrr('')
     if (!PaymentMethod) {
    alert("من فضلك اختر طريقة الدفع");
    return;
  }
    console.log('Amount', Amount)
    console.log('total', total)

    if ((parseFloat(Amount) || 0) > total) {
      setERrr('القيمة المدخلة اكبر من القيمة الكلية')
    }


    else {
      console.log("in pther")

      const error = axios.put(`https://subk.education.com.ly/back/api/invoices/${RepairOrderID}`, {
        ['Amount']: Amount,
        ['UserID']: userid,
        ['RepairOrderID']: RepairOrderID,
                ['PaymentMethod']: PaymentMethod,


      }).then(res => {
        fetchRepairOrders();

      });
      if (!error.response) {

      } else {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
      console.log(error.config);
    }
    setAmount('')
    setReastAmount('')
    setERrr('')
    setpopupModal1(false)
    settotal('')

  }


  const EditData556 = async (e, id) => {
    console.log('idedit', id);
    const response = await axios.get(`https://subk.education.com.ly/back/api/getdipositfullpayed/${id}`);
    const depositData = response.data.Deposit;
    const ArboonData = response.data.arboon;
    console.log('vvvvvvdepositDatavvvvvv', depositData);

    let singleamount = 0;
    if (depositData.length > 0) {
      setData3(depositData);

      // Map through depositData to create new objects
      const mappedData = depositData.map(deposit => {
        // Find the corresponding item in data based on OrderID
        const correspondingItem = data.find(item => item.RepairOrderID === deposit.RepairOrderID);
        singleamount += parseInt(deposit.AmountDue);
        console.log('singleamount', singleamount)
        const arboonAmount = ArboonData?.AmountDue || 0;
const reastAmount = correspondingItem
  ? (correspondingItem.TotalCost - arboonAmount - singleamount)
  : null;
       // const reastAmount = correspondingItem ? (correspondingItem.TotalCost - ArboonData.AmountDue - singleamount) : null;

        // Create a new object combining data from both sources
        return {
          AmountDue: deposit.AmountDue,
          CustomerName: correspondingItem ? correspondingItem.customer.FirstName : null,
          IssueDate: deposit.IssueDate,
          reference_number: deposit.reference_number,
          PaymentStatus: deposit.PaymentStatus,
          RestAmount: reastAmount
        };
      });

      console.log('mappedData', mappedData);

      // Update report state with mapped data
      setreport(mappedData);

      invite3.current.showInviteModal()
    } else {
      swal(" لم يتم الدفع بعد");

    }
  }
  const Nextmaintain = async (id)=> {
      console.log(id);
     data.map((item) => {
      if (id == item.RepairOrderID) {
          setData2(item)}})
        
        
       invite11.current.showInviteModal()
    }
  const maintainreport = (id) => {
    navigate(`/maintainreport/${id}`); // Navigate to the edit page
  };
  const handleEdit = (id) => {
    navigate(`/EditRepairOrder/${id}`); // Navigate to the edit page
  };
   const delay = (id) => {
const error = axios.put(`https://subk.education.com.ly/back/api/delaydeliver/${id}`).then(res => {
        fetchRepairOrders();

      });  };
  const EditData55 = async (e, id) => {
    console.log('idedit', id);

    e.preventDefault();
    const response = await axios.get(`https://subk.education.com.ly/back/api/getdiposit/${id}`);
    const depositData = response.data.Deposit;
    if (depositData) {
      setData3(depositData)
      data.map((item) => {
        if (id == item.RepairOrderID) {
          const newObj = {
            AmountDue: depositData.AmountDue,
            CustomerName: item.customer.FirstName,
            IssueDate: depositData.IssueDate,
            reference_number: depositData.reference_number,
            PaymentStatus: depositData.PaymentStatus,
            RestAmount: (item.TotalCost - item.Prepay)
          };

          console.log('data3', newObj)

          setreport(newObj)
        }

      })

      invite31.current.showInviteModal()

    } else {
      swal("لا يوجد واصل عربون");

    }




    //setID(id); setInviteModal(true)
    //getfooditeming(e, id)

    // invite3.current.generatePDF();
  }
  const EditData5558 = async (e, id) => {
    try {
      const response = await axios.get(`https://subk.education.com.ly/back/api/repairOrder/${id}`);
      setdatareparorder(response.data.RepairOrder);
      setdatareparorderDetails(response.data.RepairOrder.repair_details);

      console.log('de', response.data.RepairOrder.repair_details)
      console.log('MainOrde', response.data.RepairOrder)
      // Assuming the response data is structured correctly
    } catch (error) {
      console.error('Error fetching repair order:', error);
    }
    invite4.current.showInviteModal()


  }
  const handleDelete = async (id) => {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Once deleted, you cannot recover this record!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });
    if (willDelete) {
      await axios.delete(`https://subk.education.com.ly/back/api/repair-orders/${id}`);
      swal("Deleted successfully!", {
        icon: "success",
      });
      fetchRepairOrders();
    }
  };

  const csvHeaders = [
    { label: 'RepairOrderID', key: 'RepairOrderID' },
    { label: 'VehicleID', key: 'VehicleID' },
    { label: 'CustomerID', key: 'CustomerID' },
    { label: 'RepairDate', key: 'RepairDate' },
    { label: 'TotalCost', key: 'TotalCost' },
    { label: 'RepairStatus', key: 'RepairStatus' },
  ];

  const csvLink = {
    headers: csvHeaders,
    data: data,
    filename: "repair_orders.csv"
  };

  const tableInstance = useTable({
    columns,
    data,
    initialState: { pageIndex: 0 }
  }, useFilters, useGlobalFilter, usePagination);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    page,
    gotoPage,
    pageCount,
    pageOptions,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setGlobalFilter,
  } = tableInstance;

  const { globalFilter, pageIndex } = state;
const [chassisNumber, setChassisNumber] = useState('');
const [customerName, setCustomerName] = useState('');
const [repairDate, setRepairDate] = useState('');
const handleClearFilters = () => {
  setChassisNumber('');
  setCustomerName('');
  setRepairDate('');
  setData([]); // يمسح البيانات من الجدول
};
  return (
    <>
      <div className='container-fluid'>
        <Row>
          <Col lg="12">
            <div className="card">
            <div className="card-header">
                <h4 className="heading mb-0">عمليات الصيانة</h4>
                <Link to={"#"} className="btn btn-primary btn-sm ms-1" data-bs-toggle="offcanvas"
                   onClick={() => invite.current.showInviteModal()}
                                                            > + إضافة عملية صيانة جديدة  
 
                                </Link> 
                                       {/* <Link to={"#"} className="btn btn-primary btn-sm ms-1" data-bs-toggle="offcanvas"
                   onClick={() => invite.current.showInviteModal()}
                                                            > الكشف عن السيارة 
 
                                </Link>  */}
              </div> 
         {/* <div className="m-3 row g-2 align-items-center">
  <div className="col-md-3">
    <input
      type="text"
      placeholder="رقم الشاصي"
      className="form-control"
      value={chassisNumber}
      onChange={(e) => setChassisNumber(e.target.value)}
    />
  </div>
  <div className="col-md-3">
    <input
      type="text"
      placeholder="اسم الزبون"
      className="form-control"
      value={customerName}
      onChange={(e) => setCustomerName(e.target.value)}
    />
  </div>
  <div className="col-md-3">
    <input
      type="date"
      className="form-control"
      value={repairDate}
      onChange={(e) => setRepairDate(e.target.value)}
    />
  </div>
  <div className="col-md-3 d-flex">
    <button
      className="btn btn-primary btn-sm mx-2 flex-fill"
      onClick={fetchRepairOrders}
    >
      بحث
    </button>
    <button
      className="btn btn-secondary btn-sm flex-fill"
      onClick={handleClearFilters}
    >
      مسح الفلاتر
    </button>
  </div>
</div> */}
<form
  className="m-3 row g-2 align-items-center"
  onSubmit={(e) => {
    e.preventDefault();
    fetchRepairOrders();
  }}
>
  <div className="col-md-3">
    <input
      type="text"
      placeholder="رقم الشاصي"
      className="form-control"
      value={chassisNumber}
      onChange={(e) => setChassisNumber(e.target.value)}
    />
  </div>

  <div className="col-md-3">
    <input
      type="text"
      placeholder="اسم الزبون"
      className="form-control"
      value={customerName}
      onChange={(e) => setCustomerName(e.target.value)}
    />
  </div>

  <div className="col-md-3">
    <input
      type="date"
      className="form-control"
      value={repairDate}
      onChange={(e) => setRepairDate(e.target.value)}
    />
  </div>

  <div className="col-md-3 d-flex">
    <button
      type="submit"
      className="btn btn-primary btn-sm mx-2 flex-fill"
    >
      بحث
    </button>

    <button
      type="button"   // مهم جداً
      className="btn btn-secondary btn-sm flex-fill"
      onClick={handleClearFilters}
    >
      مسح الفلاتر
    </button>
  </div>
</form>


                   <table {...getTableProps()} className="table dataTable display table-hover">
                     <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                      {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            // Check if the column accessor is 'age' and render accordingly
                            column.id !== 'RepairOrderID' ? (
                              <th {...column.getHeaderProps()}>
                                {column.render('Header')}
                                {column.canFilter ? column.render('Filter') : null}
                              </th>
                            ) : null
                          ))}
                          <th style={{ paddingBottom: "4.5rem" }}>الباقي</th>
                          <th style={{ paddingBottom: "4.5rem" }}>العربون </th>
                          <th style={{ paddingBottom: "4.5rem" }}>الاستلام </th>
                          <th style={{ paddingBottom: "4.5rem" }}>الفاتورة </th>

                          <th style={{ paddingBottom: "4.5rem" }}>الاجراءات</th>

                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.length === 0 ? (
    <tr>
      <td colSpan={headerGroups[0].headers.length + 5} className="text-center">
        لا توجد بيانات
      </td>
    </tr>
  ) : (
                      
                      page.map(row => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                              const isidColumn = cell.column.id === 'RepairOrderID';
                              const cellProps = cell.getCellProps();
                              const cellValue = cell.render('Cell');
                              if (!isidColumn) {
                                return <td {...cellProps}>{cellValue}</td>;
                              }
                            })}
                            <td>

                              {row.original.RestAmount}
                            </td>

                            <td> <Link dir="rtl" className=""
                              to={"#"}
                              onClick={(e) => EditData55(e, row.original.RepairOrderID)}
                            > <i class="fa-solid fa-file-lines fa-2x"></i>
                            </Link>

                            </td>
                            <td> <Link dir="rtl" className=""
                              to={"#"}
                              onClick={(e) => EditData556(e, row.original.RepairOrderID)}
                            > <i class="fa-solid fa-file-lines fa-2x"></i>
                            </Link>

                            </td>
                            <td> <Link dir="rtl" className=""
                              to={"#"}
                              onClick={(e) => EditData5558(e, row.original.RepairOrderID)}
                            > <i class="fa-solid fa-file-lines fa-2x"></i>
                            </Link>
 
                            </td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="success"
                                  className="sharp i-false"
                                >
                                  {svg1}
                                </Dropdown.Toggle>
                                <Dropdown.Menu dir="rtl" style={{ minWidth: "8rem" }} className="dropdown-menu-right">
                                {/* <Dropdown.Item>

<Dropdown.Item>الريح من هده العملية :{row.original.TotalCost - row.original.TotalunitPrice}د </Dropdown.Item>

</Dropdown.Item> */}
                                  <Dropdown.Item>

                                    <Dropdown.Item onClick={() => handleEdit(row.original.RepairOrderID)}>تعديل</Dropdown.Item>

                                  </Dropdown.Item>
                                  {( row.original.RepairStatus === "مكتملة") 
 
  && (
    <Dropdown.Item>
          <Dropdown.Item onClick={() => delay(row.original.RepairOrderID)}>تسليم(دفع آجل)</Dropdown.Item>
      </Dropdown.Item>
  )
}
                                  
                                 <Dropdown.Item>
 
                                    <Dropdown.Item onClick={() => maintainreport(row.original.RepairOrderID)}>تقرير الصيانة</Dropdown.Item>

                                  </Dropdown.Item>

                                   <Dropdown.Item>
 
                                    <Dropdown.Item onClick={() => Nextmaintain(row.original.RepairOrderID)}>  الصيانة القادمة</Dropdown.Item>

                                  </Dropdown.Item>

                                  {row.original.Prepay === "null" || row.original.Prepay === "0.00" && (
                                    <Dropdown.Item>
 
                                      <Dropdown.Item onClick={() => orderlist1(row.original.RepairOrderID)}>دفع العربون</Dropdown.Item>
                                    </Dropdown.Item>


                                  )}

                              

{(row.original.RepairStatus === "مكتملة" || row.original.RepairStatus === "تم التسليم") 
 
  && (
    <Dropdown.Item>
      <Dropdown.Item onClick={() => orderlist(row.original.RepairOrderID)}>
        دفع باقي القيمة
      </Dropdown.Item>
    </Dropdown.Item>
  )
}



                                </Dropdown.Menu>
                              </Dropdown>
                            </td>

                          </tr>
                        );
                      }))
                    
                    }
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-between mx-2">
                    <span>
                      الصفحة{' '}
                      <strong>
                        {pageIndex + 1} من {pageOptions.length}
                      </strong>{''}
                    </span>
                    <span className="table-index ">
                      اذهب الى : {' '}
                      <input type="number"
                        className="ml-2"
                        defaultValue={pageIndex + 1}
                        onChange={e => {
                          const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                          gotoPage(pageNumber);
                        }}
                      />
                    </span>
                  </div>
                  <div className="text-center mb-3">
                    <div className="filter-pagination mt-3">
                      <button className="previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                        <i className='fa-solid fa-angle-right' />
                      </button>
                      <button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
                        السابق
                      </button>
                      <button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
                        التالي
                      </button>
                      <button className="next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                        <i className='fa-solid fa-angle-left' />
                      </button>
                    </div>
                  </div>
                </div>
           </Col>
        </Row>
      </div>
      <Modal className="fade bd-example-modal-sm" size="sm" id="exampleModal1" show={popupModal} centered>
        <div className="modal-content">
          <div className="modal-body">
            <div className="col-sm-12   mb-2 d-flex row ">
                 <label className="form-label">
                  القيمة :    {reastAmount}  </label>
             
                            </div>
            <div className="col-sm-12  mb-2 d-flex row" >

                 <label style={{ whiteSpace: "nowrap" }} className="form-label">ادخل باقي القيمة<span className="text-danger">*</span></label>
               <input type="text"
                className="form-control"
                defaultValue=''

                //placeholder="ادخل قيم عددية صحيحه  فقط"
                required
                id="inputcity"
                name="city"
                onChange={(e) => setAmount(e.target.value)} ></input>

            </div>
                <div className="col-md-12 d-flex mb-2 row ">
                                        <label className="form-label m-1" style={{ whiteSpace: "nowrap" }}>طريقة الدفع:</label>
                                        <select
                                        required
                                            className="form-control"
                                            name="Paid"
                                            value={PaymentMethod}
                                             onChange={(e) => setPaymentMethod(e.target.value)}
                                        >
                                            <option value="" >اختر</option>
                                            <option value="cash">كاش</option>
                                            <option value="card">بطاقة</option>
                                        </select>
                                    </div>
            <div style={{ color: "red" }}>{Err}</div>
            <div className="card-footer" >
                 <button type="button" className="btn btn-primary light mx-1" onClick={handleEdit1}>إضافة</button> 

 
              <button type="button" className="btn btn-danger light" onClick={() => setpopupModal(false)}>اغلاق</button>
            </div>
          </div>
        </div>

      </Modal>
      <Modal className="fade bd-example-modal-sm" size="sm" id="exampleModal1" show={popupModal1} centered>
        <div className="modal-content">
          <div className="modal-body">
            <div className="col-sm-12 d-flex mb-2">
             


                 <label style={{ whiteSpace: "nowrap" }} className="form-label   ">
                       قيمة العربون:</label>
                
              <input type="text"
                className="form-control"
                defaultValue=''

                //placeholder="ادخل قيم عددية صحيحه  فقط"
                required
                id="inputcity"
                name="city"
                onChange={(e) => setAmount(e.target.value)} ></input>

            </div>
             <div className="col-md-12 d-flex mb-2">
                                        <label className="form-label m-1" style={{ whiteSpace: "nowrap" }}>طريقة الدفع:</label>
                                        <select
                                        required
                                            className="form-control"
                                            name="Paid"
                                            value={PaymentMethod}
                                             onChange={(e) => setPaymentMethod(e.target.value)}
                                        >
                                            <option value="" >اختر</option>
                                            <option value="cash">كاش</option>
                                            <option value="card">بطاقة</option>
                                        </select>
                                    </div>
            <div style={{ color: "red" }}>{Err}</div>
            <div className="card-footer" >
               
                 <button type="button" className="btn btn-primary light mx-1" onClick={handledeposit} > إضافة</button> 

              <button type="button" className="btn btn-danger light" onClick={() => setpopupModal1(false)}>اغلاق</button>
            </div>
          </div>
        </div>

      </Modal>
      <InviteCustomer31
        ref={invite31} data={report}
      />
      <InviteCustomer
        ref={invite} 
      />
      <InviteCustomer4
        ref={invite4} data={datareparorder} data1={datareparorderDetails}
      />
      <InviteCustomer3
        ref={invite3} data={report}
      />
      <InviteCustomer11
        ref={invite11} data={data2}
      />
    </>
  );
});

export default RepairOrders;
